export default function getStorageConfig() {
  const host = window.location.hostname;
  console.log("Storage host:", host);

  switch (host) {
    case "www.uat.portal.rcshealth.io":
    case "uat.portal.rcshealth.io":
      // case "localhost":
      // return {
      //   bucket: "rcs-health-uat",
      //   region: "us-east-1",
      //   defaultAuthMode: "userPool",
      // };
        return {
        bucket: "rcs-health-uat-v2",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };

    case "www.dev,portal.rcshealth.io":
    case "dev.portal.rcshealth.io": //TODO: Remove this
          // case "localhost":
      // return {
      //   bucket: "rcs-health-dev",
      //   region: "us-east-1",
      //   defaultAuthMode: "userPool",
      // };
      return {
        bucket: "rcs-health-dev-v2",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };

    case "www.portal.rcshealth.io":
    case "portal.rcshealth.io":
    case "localhost":
      return {
        bucket: "rcs-health-prod1",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };


    default:
      return {
        bucket: "rcs-health-dev",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };
  }
}
